import { z } from 'zod';
import { defineIndexPath, definePath } from '../../router/definePath';

// Base path for the payment subtree. It carries a layout route; the read view renders at the
// index child (`paymentIndex`) and the edit surface at `paymentEdit`, mirroring the account
// credentials subtree (read view + separate `update-*` edit routes).
const payment = definePath(
  'authenticated',
  { de: '/konto/zahlungsdaten', en: '/account/payment' },
  // One-shot confirmation carried across the edit → read navigation. Declared on the parent so the index
  // child inherits it; `defineLayoutRoute` never wires `validateSearch`, only `definePageRoute` does.
  { search: z.object({ result: z.literal('success').optional() }) },
);

export const BillingPaths = {
  payment,
  /** Index child of `payment` — renders the read view at the payment URL. */
  paymentIndex: defineIndexPath(payment),
  paymentEdit: definePath('authenticated', { de: '/konto/zahlungsdaten/bearbeiten', en: '/account/payment/edit' }),
  invoices: definePath(
    'authenticated',
    { de: '/konto/rechnungen', en: '/account/invoices' },
    // `year` preselects the invoice-year dropdown so the view is shareable/bookmarkable.
    { search: z.object({ year: z.number().int().optional() }) },
  ),
} as const;
